import React from 'react'

import { RatablesFilterTypes } from './Ratables'

interface FilterState {
  selectedFilters: string[]
}

export type RatablesFilterProps = {
  handleFilterClick: (selectedFilters: string[]) => void
}

export class RatablesFilter extends React.Component<
  RatablesFilterProps,
  FilterState
> {
  state: Readonly<FilterState> = {
    selectedFilters: []
  }

  handleClick = (filterType: string) => {
    const { handleFilterClick } = this.props
    let { selectedFilters } = this.state

    if (selectedFilters.includes(filterType)) {
      selectedFilters = selectedFilters.filter((item) => item !== filterType)
    } else {
      selectedFilters.push(filterType)
    }

    this.setState({ selectedFilters })

    handleFilterClick(selectedFilters)
  }

  renderItem = (filterType: string) => {
    const { selectedFilters } = this.state
    const isChecked = selectedFilters.includes(filterType)
    return (
      <div className="search__issues--type">
        <input
          type="checkbox"
          value={filterType}
          checked={isChecked}
          onChange={() => this.handleClick(filterType)}
        />
        <span
          onClick={() => this.handleClick(filterType)}
          onKeyUp={() => this.handleClick(filterType)}
          role="button"
          tabIndex={0}
        >
          {filterType}
        </span>
      </div>
    )
  }

  render() {
    return (
      <>
        <div className="heading--6">Filter</div>
        <div className="search__issues">
          <form className="search__issues--form" name="issue__form">
            {this.renderItem(RatablesFilterTypes.INTERNATIONAL)}
            {this.renderItem(RatablesFilterTypes.NATIONAL)}
            {this.renderItem(RatablesFilterTypes.SHORT_TERM)}
            {this.renderItem(RatablesFilterTypes.LONG_TERM)}
            {this.renderItem(RatablesFilterTypes.SPECULATIVE_GRADE)}
            {this.renderItem(RatablesFilterTypes.INVESTMENT_GRADE)}
          </form>
        </div>
      </>
    )
  }
}
export default RatablesFilter
